import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn'; // We'll create a simple utility or just inline it if preferred, but let's stick to simple props for now
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-hover shadow-lg shadow-terracotta/20',
    secondary: 'bg-sage text-white hover:bg-sage-dark shadow-lg shadow-sage/20',
    outline: 'border-2 border-terracotta text-terracotta hover:bg-terracotta/5'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-132">
      {children}
    </motion.button>;
}